import { sortByValues } from 'Common/filterValues';
import * as R from 'ramda';

const mappings = {
  make: 'derivative.make',
  urlmake: 'derivative.urlmake',
  model: 'derivative.range',
  trim: 'derivative.trim',
  urlmodel: 'derivative.urlrange',
  withinDistance: 'dealer.withinDistance',
  fuelType: 'derivative.fuelType',
  gearBox: 'derivative.transmission',
  category: 'derivative.category',
  colour: 'colour',
  doors: 'derivative.doors',
  seats: 'technical.no_of_seats',
  urlcarType: 'derivative.urlcategory',
  yearFrom: 'yearFrom',
  yearTo: 'yearTo',
  dealerId: 'dealer.id'
};

export default form => {
  const formValues = form.values ? form.values : {};

  const getKey = key => mappings[key] || key;
  const valueUrlEncode = k => {
    const key = getKey(k);
    if (key && formValues[k]) {
      const valueFromJSON = JSON.parse(formValues[k]).key;
      const urlValue =
        R.type(valueFromJSON) === 'String' && !key.includes('.id')
          ? valueFromJSON.toLowerCase()
          : valueFromJSON;
      return `${encodeURIComponent(key)}=${encodeURIComponent(urlValue)}`;
    }

    return '';
  };

  const rangeUrl = key => k => {
    const val = JSON.parse(formValues[k]);
    let url = '';
    if (val.from) {
      url = url + `${key}From=${encodeURIComponent(val.from)}`;
    }
    if (val.to) {
      url = url + `${key}To=${encodeURIComponent(val.to)}`;
    }
    return url;
  };

  const sortByUrl = key => {
    const sortByValue = sortByValues.filter(
      _ => _.key === JSON.parse(formValues['sortBy']).key
    )[0];
    return `sort=${sortByValue.sort}&sortBy=${sortByValue.sortBy}`;
  };

  const customUrl = {
    mileage: rangeUrl('mileage'),
    annualTax: rangeUrl('derivative.annualTax'),
    fuelConsumption: rangeUrl('technical.ec_combined_mpg'),
    co2Emissions: rangeUrl('technical.co2_gkm'),
    acceleration: rangeUrl('technical.0_to_62_mph_secs'),
    insuranceGroup: rangeUrl('technical.insuranceGroup'),
    engineSizeFrom: rangeUrl('technical.badge_engine_cc'),
    engineSizeTo: rangeUrl('technical.badge_engine_cc'),
    keyword: k => `searchTerm=${encodeURIComponent(formValues[k])}`,
    used: k => `used=${formValues.used}`,
    nearlynew: k => `nearlynew=${formValues.nearlynew}`,
    postCode: k =>
      formValues.isPostCodeValid
        ? `postCode=${encodeURIComponent(formValues[k])}`
        : '',
    sortBy: k => sortByUrl(),
    isPostCodeValid: () => ''
  };
  const getUrlString = k => {
    const urlFn = customUrl[k] || valueUrlEncode;
    return urlFn(k);
  };

  const urlParts = R.keys(formValues)
    .filter(k => formValues[k] !== null)
    .filter(
      k =>
        !(
          k === 'withinDistance' &&
          formValues.withinDistance &&
          !formValues.isPostCodeValid
        )
    )
    .map(getUrlString)
    .filter(i => i !== '');

  return urlParts.join('&');
};



// WEBPACK FOOTER //
// ./src/Common/getQueryString/index.js